import React from 'react';
import ReactDOM from 'react-dom';
import Blog from './Blog';
import reportWebVitals from './reportWebVitals';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
      <Blog />
  </React.StrictMode>,
);

reportWebVitals();
